import { NgModule } from '@angular/core';
import { SidenavComponent } from './sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [MatSidenavModule,CommonModule,RouterModule,MatIconModule, MatButtonModule,],
    exports: [SidenavComponent],
    declarations: [SidenavComponent],
    providers: [],
})
export class SidenavModule { }
